import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy `/account/add-facility` route — superseded by the modal flow at
 * `_authenticated` layout (`?add=facility&step=N`). See `add-provider.tsx`
 * for the rationale.
 */
export const Route = createFileRoute("/_authenticated/account/add-facility")({
  validateSearch: (search: Record<string, unknown>): { step?: number } => ({
    step:
      typeof search.step === "number"
        ? search.step
        : typeof search.step === "string"
          ? Number.parseInt(search.step, 10) || undefined
          : undefined,
  }),
  beforeLoad: ({ search }) => {
    const aStep = search.step;
    throw redirect({
      to: "/account/user/dashboard",
      search: aStep ? { add: "facility", aStep } : { add: "facility" },
    });
  },
});
